// @flow
import GeoSearchControl from './GeoSearchControl'
import { createFormGroupField } from '@src/components/ui/FormGroup'

export default createFormGroupField(GeoSearchControl)
